import { styled } from '@abyss/web/tools/styled';

export const HiddenFormSubmission = styled('form', {
  display: 'none',
});

export const guestScheduleModalStyles = {
  'abyss-modal-content-container': {
    width: '572px',
    '& .abyss-modal-content-title': {
      fontSize: '32.43px',
      fontWeight: '600',
      padding: '8px 16px',
    },
  },
  'abyss-modal-header-container': {
    padding: '0',
  },
};

export const guestScheduleModalInfoStyles = {
  '&.abyss-modal-section-root': {
    fontSize: '16px',
    fontWeight: '500',
    padding: '16px',
  },
};
